module.exports = __webpack_public_path__ + "img/spongebob_squarepants_episode.e29d5bef.jpg";